import {Outlet} from "react-router-dom";
import AdminHeader from "../../components/admin/AdminHeader";
import ScrollToTop from "../../util/ScrollToTop";
import React from "react";
import Footer from "../../components/common/Footer";
import useGoogleAdsPageView from "../../hooks/useGoogleAdsPageView";

export default function AdminRootLayout() {
    // Track PageView events for Google Ads
    useGoogleAdsPageView();

    return <>
        <ScrollToTop/>
        <AdminHeader/>
        <Outlet/>
        <Footer/>
    </>
}